import ApiService from '@/common/api.service'
// import AlertService from '@/common/alert.service'
// import KullaniciYonetimService from '@/common/custom-service/management/KullaniciYonetimService'

const state = {
  
}

const getters = {
  
}

const mutations = {
  
}

const actions = {
  fetchUsers(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('user/getall', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  fetchUser(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`user/get/${queryParams.id}`, {}, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  saveUser(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('user/save', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  deleteUser(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`user/delete/${queryParams.id}`, {}, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  async createToken(ctx, queryParams) {
    const response = await ApiService.post('user/create-token', queryParams, this);
    if (response.statusCode === 200) {
      const url = `http://lab.illustrativedna.com/loginguid/${response.result}`;
      const newwindow = window.open(url, 'User page', 'height=800,width=1100');
      if (window.focus) {
        newwindow.focus()
      }
    }
    return response;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
